export default {
    state: {
        abonos: [],
    },
    getters: {
        abonos: state => state.abonos || [],
    },
    mutations: {
        SET_ABONOS: (state, payload) => state.abonos = payload,
    },
    actions: {
        refresh_abonos({commit}, payload) {
            commit('SET_ABONOS', payload)
        }
    }
}